import { useNavigate } from "react-router-dom"
import blogMain from "../../assest/images/blogmain.jpg"
import BlogListCard from "../../components/BlogListCard"
import CustomAdvanceDropdown from "../../components/CustomAdvanceDropdown"
import BreadCrumb from "../../components/BreadCrumb"

const Index = ({
    blogList,
    nextPageUrl,
    isBlogsLoading,
    // onClickLoadMore,
    isLoading,
    blogCategoryList,
    handleKeyDown,
    inputValue,
    setInputValue,
    onPageChange,
    totalItems,
    totalPages,
    currentPage,
    slugLang,
    breadcrumbList
}) => {
    // console.log(blogCategoryList);
    const navigate = useNavigate()

    return (
        <>
            <section className="mainBanner mb-2" style={{ backgroundImage: `url(${blogMain})` }}>
                <div className="bannerBox">
                    <div className="container">
                        <div className="bannerText">
                            <div className="sliderText">
                                <h2>Learn More About Tours</h2>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
              <div className="container">
                <BreadCrumb list={breadcrumbList} />
            </div>

            <div className="container blogContainer" style={{
                display: 'flex',
                justifyContent: "space-between",
                alignItems: "center",
                flexWrap: "wrap"
            }}>
                <div className="blogSearch">
                    <input
                        type="text"
                        className="commonInput"
                        value={inputValue}
                        onChange={(e) => setInputValue(e.target.value)}
                        onKeyDown={handleKeyDown}
                        placeholder="Search..."
                    />
                    <i className="fa-solid fa-magnifying-glass"></i>
                </div>
                <div className="blog-cat-opt">
                    <CustomAdvanceDropdown
                        label={''}
                        options={blogCategoryList}
                        selectedState={{ name: "Select Category" }}
                        optionType="multiple"
                        setSelectedState={(e) => {
                            navigate('/'+slugLang + '/blog/category/' + e.slug)
                        }}
                    />
                </div>
            </div>

            <BlogListCard
                blogList={blogList}
                nextPageUrl={nextPageUrl}
                isBlogsLoading={isBlogsLoading}
                // onClickLoadMore={onClickLoadMore}
                onPageChange={onPageChange}
                isLoading={isLoading}
                totalPages={totalPages}
                totalItems={totalItems}
                currentPage={currentPage}
            />
        </>
    )
}
export default Index